// extracted by mini-css-extract-plugin
module.exports = {"emailForm":"styles_emailForm__1dV66","spinner":"styles_spinner__2xg4k"};